import { ADD_ENTITIES } from "../actions/actions";
import { mergeEntitiesWithState, priceEstimated } from "../helpers/schema";

const schema = priceEstimated;

export function pricesEstimated(
  state = {
    all: {},
  },
  action
) {
  switch (action.type) {
    case ADD_ENTITIES:
      let data = action.payload.priceEstimated;
      if (!data) return state;

      return {
        ...state,
        all: mergeEntitiesWithState(data, state.all, schema),
      };
    default:
      return state;
  }
}
